import PrimaryIcon from "@assets/images/pin.svg";
import Unstar from "@assets/icons/fluent_star-off-24-filled.svg";
import { MoreVert as ThreeDotIcon } from "@mui/icons-material";
import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlined";
import FavoriteBorderOutlinedIcon from "@mui/icons-material/FavoriteBorderOutlined";
import PublicIcon from "@mui/icons-material/Public";
import ShareOutlinedIcon from "@mui/icons-material/ShareOutlined";
import InfoOutlineIcon from "@mui/icons-material/InfoOutlined";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import FavoriteIcon from "@mui/icons-material/Favorite";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import DownloadIcon from "@mui/icons-material/Download";
import {
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
} from "@mui/material";
import React, { useState, useEffect } from "react";
import { useQueryClient } from "react-query";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import FlagIcon from "@mui/icons-material/Flag";
import cloneSvg from "@assets/images/clone_green.svg";
import { ReactComponent as DuplicateIcon } from "@assets/icons/wheelMenuIcons/Duplicate.svg";
import { ReactComponent as EditIcon } from "@assets/icons/wheelMenuIcons/Edit.svg";
import { ReactComponent as ShareIcon } from "@assets/icons/wheelMenuIcons/Share.svg";
import { ReactComponent as UnlockIcon } from "@assets/icons/wheelMenuIcons/unlock.svg";
import DriveFileMoveIcon from "@mui/icons-material/DriveFileMove";
import AccessKeyEnterModal from "../AccessKeyEnterModal";
import {
  useCloneWheel,
  useDeleteWheelV2,
  useFavoriteWheel,
  useRemovePrimaryWheel,
  useUnlockWheelV2,
  useUpdatePrimaryWheel,
  useUpdateWheelVisibilityV2,
} from "../../services/mutations";
import { colors } from "../../utils";
import { Dropdown } from "react-bootstrap";
import { ASSETS } from "../../utils/config";
import LegacyWheelModal from "../WheelGallery/WheelListing/ListComponents/LegacyWheelModal";
import { QUERY_KEYS } from "../../utils/config";
import BackdropSpinner from "../WheelGallery/WheelListing/ListComponents/BackdropSpinner";
import { useDispatch } from "react-redux";
import { closeModal, openModal } from "../../redux/reducers/dialog";
import {
  setReportInstance,
  setReportLocation,
  setReportModalOpen,
} from "../../redux/actions";
import MoveToFolderModal from "../Folders/MoveToFoldersModal";
import { Menu, MenuButton, MenuItem } from "@szhsin/react-menu";
import { canCloneWheel, getWheelDetails, takeWheelScreenshot } from "../../services/api";
import { WheelLimitPopup } from "../WheelLimitPopup";
import {
  closeDialogPopup,
  openDialogPopup,
} from "../../redux/reducers/dialogPopup";
import ShareModal from "../ShareModal";
import { clearPrimaryWheel } from "../../redux/reducers/gallery";
import StarIcon from "@mui/icons-material/Star";
import { isUserLoggedIn } from "../../utils/helpers";
import { openNonAuthenticatedModal } from "../../redux/reducers/nonAuthenticatedModal";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { ReactComponent as CloneGreen } from "@assets/images/clone_green.svg";
import { ReactComponent as LockedIcon } from "@assets/images/unlock_yellow.svg";
// Screenshot functionality moved to backend Lambda
// import ScreenshotModal from "../../pages/ViewWheel/ScreenshotModal";
// import { useScreenshot } from "use-react-screenshot";
// import { getWheelUploadPath, handleFileUpload } from "../../utils/fileUpload";
import { getLoggedInUser, fetchImageAsBase64 } from "../../utils/helpers";
// import { postWheelScreenshot } from "../../services/api";
import DefaultIyugaLogo from "@assets/images/iyuga.jpg";
import { openGeneralDialogModal } from "../../redux/reducers/generalDialog";

export const menuItemKeys = {
  VIEW: "view",
  EDIT: "edit",
  PRIMARY: "primary",
  REMOVE_PRIMARY: "remove-primary",
  VISIBILITY: "visibility",
  DUPLICATE: "duplicate",
  SHARE: "share",
  DELETE: "delete",
  FAVORITE: "favourite",
  CLONE: "clone",
  REPORT: "report",
  MOVE: "move",
  DOWNLOAD: "download",
  UNLOCK: "unlock",
};

// Add visibility constants at the top of the file
const VISIBILITY = {
  PUBLIC: 1,
  PRIVATE: 2,
  HIDDEN: 3,
};

const WheelCardThreeDotMenu = ({
  data,
  exclude = [],
  include = [],
  onWheelDelete = () => {},
  refetchPrimaryOnFavourite = false,
  customMenuItems = [],
}) => {
  const dispatch = useDispatch();
  const [openPopup, setOpenPopup] = useState(false);
  const [showDropdown, setShowDropdown] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [showMoveToFolderModal, setShowMoveToFolderModal] = useState(false);
  const nav = useNavigate();
  const updatePrimaryWheel = useUpdatePrimaryWheel();
  const removePrimaryWheel = useRemovePrimaryWheel();
  const deleteWheelFunc = useDeleteWheelV2();
  const unlockWheel = useUnlockWheelV2();
  const updateVisibility = useUpdateWheelVisibilityV2();
  const cloneWheel = useCloneWheel();
  const favoriteWheel = useFavoriteWheel();
  const queryClient = useQueryClient();
  const wheelId = data?.id;
  const [showLegacyModal, setshowLegacyModal] = useState(false);
  const [isAccessKeyModalOpen, setIsAccessKeyModalOpen] = useState(false);
  const [accessKeyError, setAccessKeyError] = useState("");
  const [accessKeyModalContext, setAccessKeyModalContext] = useState("unlock"); // "unlock" or "clone"

  const isOpenMenuWheelClonable = data?.is_clonable;
  const isOpenMenuWheelLive = data?.is_live;
  const isOpenMenuWheelCloned = data?.is_cloned;
  const isOpenMenuWheelLocked = data?.is_locked;
  const isOpenMenuWheelFavorited = data?.is_favourite;
  const isAlreadyCloned = data?.already_cloned;
  const [openShare, setOpenShare] = useState(false);
  // Screenshot functionality moved to backend Lambda
  // const [isScreenshotModalOpen, setIsScreenshotModalOpen] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  // const [screenshotImage, takeScreenshot] = useScreenshot();
  const [base64Wallpaper, setBase64Wallpaper] = useState(null);
  const [showPrimaryDialog, setShowPrimaryDialog] = useState(false);
  const userData = {
    id: data?.user_profile?.user_id || 1,
    url:
      data?.wheel_image ||
      "https://static.wixstatic.com/media/873c71_7cf29d8fa600414fb56f62fa5aa3522f~mv2.png/v1/fit/w_2500,h_1330,al_c/873c71_7cf29d8fa600414fb56f62fa5aa3522f~mv2.png",
  };

  const wheelBackground = data?.data?.wallpaper_image
    ? `url(${data?.data?.wallpaper_image})`
    : data?.gradient_color_code
    ? data?.gradient_color_code
    : "none";

  // Additional data for screenshot functionality
  const [wheelData, setWheelData] = useState(data);

  // Update local wheelData when data prop changes
  useEffect(() => {
    setWheelData(data);
  }, [data]);


  // const { wallpaper_transparency, bg_wallpaper, segment_bg_color, current_bg } =
  //   data?.wallpaper_settings;

  // Convert wallpaper to base64 for screenshot
  useEffect(() => {
    const convertWallpaperToBase64 = async () => {
      const bgWallpaper = data?.wallpaper_settings?.bg_wallpaper;
      if (bgWallpaper && bgWallpaper?.startsWith("http")) {
        try {
          const base64 = await fetchImageAsBase64(bgWallpaper);
          setBase64Wallpaper(base64);
        } catch (error) {
          console.error("Error converting wallpaper to base64:", error);
          setBase64Wallpaper(bgWallpaper);
        }
      } else {
        setBase64Wallpaper(bgWallpaper);
      }
    };

    convertWallpaperToBase64();
  }, [data?.wallpaper_settings?.bg_wallpaper]);


  const handleView = () => {
    const path =
      `/wheel/${data.id}`;
    nav(path);
  };

  const handleEdit = () => {
    if (data.version === 2) {
      window.location.href = `/builder/${data.id}`;
    } else {
      setshowLegacyModal(true);
    }
  };

  const handlePrimaryWheelUpdate = () => {
    setIsLoading(true);

    const onSuccess = () => {
      queryClient.invalidateQueries([QUERY_KEYS.useGetPrimaryWheel]);
      queryClient.invalidateQueries(["fetchWheels"]);
      toast.success("Primary wheel successfully updated");
    };

    const onError = () => toast.error("Failed to set Primary Wheel.");

    const onSettled = () => setIsLoading(false);

    updatePrimaryWheel.mutate(data.id, { onSuccess, onError, onSettled });
  };

  const handleMakePrimary = () => {
    if (data?.visibility === 2 || data?.visibility === 3) {
      setShowPrimaryDialog(true);
    } else {
      handlePrimaryWheelUpdate();
    }
  };

  const handleProceedPrimary = () => {
    handlePrimaryWheelUpdate();
    setShowPrimaryDialog(false);
  };

  const handleCancelPrimary = () => {
    setShowPrimaryDialog(false);
  };

  const handleRemovePrimary = () => {
    setIsLoading(true);
    removePrimaryWheel.mutate(data.id, {
      onSuccess: () => {
        queryClient.invalidateQueries([QUERY_KEYS.useGetPrimaryWheel]);
        queryClient.invalidateQueries(["fetchWheels"]);
        toast.success(`Primary wheel removed successfully`);
        dispatch(clearPrimaryWheel());
      },
      onError: () => toast.error("Failed to remove Primary Wheel."),
      onSettled: () => setIsLoading(false),
    });
  };

  const handleToggleVisibility = () => {
    const isPrimaryWheel = data?.is_primary;
    const currentVisibility = data?.visibility;
    const newVisibility =
      currentVisibility === VISIBILITY.PRIVATE
        ? VISIBILITY.PUBLIC
        : VISIBILITY.PRIVATE;

    // Show confirmation dialog for primary wheels
    if (currentVisibility === VISIBILITY.PUBLIC && isPrimaryWheel) {
      dispatch(
        openDialogPopup({
          isOpen: true,
          title: "Make This Wheel Private?",
          primaryButtonTitle: "Proceed",
          secondaryButtonTitle: "Cancel",
          text: "This is a Primary Wheel, making it Private will remove it from being a Primary Wheel.",
          secondaryButtonOnClick: () => dispatch(closeDialogPopup()),
          primaryButtonOnClick: () => {
            handleRemovePrimary();
            updateWheelVisibility(newVisibility);
          },
        })
      );
    } else {
      updateWheelVisibility(newVisibility);
    }
  };

  const updateWheelVisibility = (newVisibility) => {
    setIsLoading(true);
    updateVisibility.mutate(
      { wheelId: data.id, visibility: newVisibility },
      {
        onSuccess: () => {
          const visibilityText =
            newVisibility === VISIBILITY.PUBLIC ? "Public" : "Private";
          toast.success(`Wheel visibility changed to ${visibilityText}.`);
          queryClient.invalidateQueries(["fetchWheels"]);
        },
        onError: () => {
          toast.error("Failed to change visibility.");
        },
        onSettled: () => {
          setIsLoading(false);
          dispatch(closeDialogPopup());
        },
      }
    );
  };

  const handleDuplicate = () => {
    setIsLoading(true);
    cloneWheel.mutate(
      { wheelId: data.id },
      {
        onSuccess: () => {
          queryClient.invalidateQueries(["fetchWheels"]);
          toast.success(`Wheel duplicated successfully.`);
        },
        onError: () => toast.error("Failed to duplicate Wheel."),
        onSettled: () => setIsLoading(false),
      }
    );
  };

  const handleShare = async () => {
    const needsScreenshot =
      wheelData?.wheel_preview === null ||
      wheelData?.wheel_preview === undefined ||
      wheelData?.wheel_preview === "" ||
      !wheelData?.wheel_preview.includes("wheel-screenshot");

    if (needsScreenshot) {
      try {
        // Call backend Lambda to take screenshot
        await takeWheelScreenshot(wheelId);
        console.log("Screenshot taken successfully by backend Lambda");

        // Refetch the wheel data from API to get the updated wheel_preview
        console.log("Refetching wheel data from API...");
        const response = await getWheelDetails(wheelId, "");

        if (response?.data?.data) {
          console.log("Wheel data refetched successfully", response.data.data);
          // Update local wheelData with fresh API data
          setWheelData(response.data.data);
        }

        // Also invalidate queries to update the cache in background
        queryClient.invalidateQueries(["fetchWheels"]);

        // Now open the share modal with updated data
        setOpenShare(true);
      } catch (error) {
        console.error("Error taking wheel screenshot:", error);
        // Open share modal anyway, even if screenshot failed
        setOpenShare(true);
      }
    } else {
      // Preview already exists, open share modal directly
      setOpenShare(true);
    }
  };

  const handleDownload = async () => {
    try {
      const response = await fetch(data.wheel_preview);
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `wheel_image_${data.id}.png`;
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);
    } catch (error) {
      console.error("Error downloading image:", error);
      toast.error("Failed to download image. Please try again.");
    }
  };

  const handleCloneAction = (action) => {
    setIsLoading(true);
    cloneWheel.mutate(
      { wheelId: wheelData?.id, action },
      {
        onSuccess: () => toast.success(`Wheel cloned successfully.`),
        onError: (error) => {
          const errorMessage =
            error?.response?.data?.message || "Failed to clone Wheel.";
          toast.error(errorMessage);
        },
        onSettled: () => setIsLoading(false),
      }
    );
  };

  const handleClone = async () => {
    const isLoggedIn = isUserLoggedIn();
    if (!isLoggedIn) {
      dispatch(
        openNonAuthenticatedModal({
          title: "Clone Wheel?",
          action: "Clone",
          type: "wheel",
          headerIcon: CloneGreen,
          headerIconProps: {
            style: {
              width: "24px",
              height: "24px",
            },
          },
        })
      );
      return;
    }
    if (isAlreadyCloned) {
      dispatch(
        openGeneralDialogModal({
          isOpen: true,
          title1: "You have already cloned this wheel!",
          primaryButtonTitle: "Create a New Clone",
          imageSrc: ASSETS.DialogImg,
          primaryButtonOnClick: () => {
            handleCloneAction("new");
          },
          secondaryButtonTitle: "Replace Previous Clone",
          secondaryButtonOnClick: () => {
            handleCloneAction("overwrite");
          },
        })
      );
      return;
    }
    setIsLoading(true);
    try {
      const response = await canCloneWheel();
      if (response.status === 200) {
        cloneWheel.mutate(
          { wheelId: data.id, action: "new" },
          {
            onSuccess: () => toast.success(`Wheel cloned successfully.`),
            onError: (error) => {
              const errorMessage =
                error?.response?.data?.message || "Failed to clone Wheel.";
              if (
                error.status === 400 &&
                error.response?.data?.message ===
                  "You dont have permission to clone this wheel"
              ) {
                setIsLoading(false);
                setAccessKeyError("");
                setAccessKeyModalContext("clone");
                setIsAccessKeyModalOpen(true);
                return;
              }
              toast.error(errorMessage);
            },
            onSettled: () => setIsLoading(false),
          }
        );
      }
      if (response.status === 403) {
        setIsLoading(false);
        dispatch(
          openDialogPopup({
            isOpen: true,
            title: "Upgrade to Clone More Wheels!",
            primaryButtonTitle: "Upgrade today!",
            secondaryButtonTitle: "Cancel",
            text: "You've reached your limit of 5 Clones. Upgrade your plan to unlock unlimited Wheel clones and enjoy all of the additional features!",
            secondaryButtonOnClick: () => dispatch(closeDialogPopup()),
            primaryButtonOnClick: () => {
              dispatch(closeDialogPopup());
              nav("/settings?option=subscriptions");
            },
          })
        );
      }
      if (
        response.data?.status_code === 400 &&
        response.data?.message ===
          "You dont have permission to clone this wheel"
      ) {
        setIsLoading(false);
        setAccessKeyError("");
        setAccessKeyModalContext("clone");
        setIsAccessKeyModalOpen(true);
        return;
      }
    } catch (err) {
      if (err.status === 403) {
        setIsLoading(false);
        dispatch(
          openDialogPopup({
            isOpen: true,
            title: "Upgrade to Clone More Wheels!",
            primaryButtonTitle: "Upgrade today!",
            secondaryButtonTitle: "Cancel",
            text: "You've reached your limit of 5 Clones. Upgrade your plan to unlock unlimited Wheel clones and enjoy all of the additional features!",
            secondaryButtonOnClick: () => dispatch(closeDialogPopup()),
            primaryButtonOnClick: () => {
              dispatch(closeDialogPopup());
              nav("/settings?option=subscriptions");
            },
          })
        );
      }
      if (
        err.status === 400 &&
        err.response?.data?.message ===
          "You dont have permission to clone this wheel"
      ) {
        setIsLoading(false);
        setAccessKeyError("");
        setAccessKeyModalContext("clone");
        setIsAccessKeyModalOpen(true);
        return;
      }
    }
  };

  const handleDelete = () => {
    dispatch(
      openModal({
        title: "Delete Wheel",
        subtitle: "Are you sure you want to delete this Wheel?",
        onCancel: () => dispatch(closeModal()),
        onConfirm: () => {
          deleteWheelFunc.mutate(wheelId, {
            onSuccess: () => {
              onWheelDelete(wheelId);
              queryClient.invalidateQueries(["fetchWheels"]);
              toast.success(`Wheel deleted successfully.`);
            },
            onError: () => {
              toast.error("Failed to delete Wheel.");
            },
          });
        },
      })
    );
  };

  const handleFavorite = () => {
    const isLoggedIn = isUserLoggedIn();
    if (!isLoggedIn) {
      dispatch(
        openNonAuthenticatedModal({
          title: "Favorite Wheel?",
          action: "Favorite",
          type: "wheel",
          headerIcon: FavoriteIcon,
          headerIconProps: {
            sx: { color: "#E25297", width: "24px", height: "24px" },
          },
        })
      );
      return;
    }
    setIsLoading(true);
    favoriteWheel.mutate(data.id, {
      onSuccess: (response) => {
        const newFavoriteStatus = response.data.data.is_favourite;
        // Update the wheels cache with new favorite status
        queryClient.setQueriesData(["fetchWheels"], (oldData) => {
          if (!oldData) return oldData;
          return {
            ...oldData,
            pages: oldData.pages.map((page) => ({
              ...page,
              results: page.results.map((wheel) =>
                wheel.id === data.id
                  ? { ...wheel, is_favourite: newFavoriteStatus }
                  : wheel
              ),
            })),
          };
        });
        queryClient.invalidateQueries(["fetchWheels"]);

        // If this is the primary wheel, refetch it to update favorite status
        if (refetchPrimaryOnFavourite) {
          queryClient.invalidateQueries([QUERY_KEYS.useGetPrimaryWheel]);
        }

        toast.success(
          `Wheel ${
            newFavoriteStatus ? "favorited" : "unfavorited"
          } successfully.`
        );
      },
      onError: () => toast.error("Failed to update favorite status."),
      onSettled: () => setIsLoading(false),
    });
  };

  const handleReport = () => {
    const isLoggedIn = isUserLoggedIn();
    if (!isLoggedIn) {
      dispatch(
        openNonAuthenticatedModal({
          title: "Report Wheel?",
          action: "report",
          type: "wheel",
          headerIcon: InfoOutlinedIcon,
          headerIconProps: {
            sx: { color: "#E54D2E", width: "24px", height: "24px" },
          },
        })
      );
      return;
    }
    dispatch(setReportModalOpen(true));
    dispatch(setReportInstance(data?.id));
    dispatch(setReportLocation("WHEEL"));
  };

  const handleMoveToFolder = () => {
    setShowMoveToFolderModal(true);
  };

  const handleMoveComplete = ({ sourceType, sourceId, targetFolderId }) => {
    setShowMoveToFolderModal(false);
    queryClient.invalidateQueries(["fetchWheels"]);
    toast.success("Wheel moved successfully");
  };

  const handleUnlock = () => {
    const isLoggedIn = isUserLoggedIn();
    if (!isLoggedIn) {
      dispatch(
        openNonAuthenticatedModal({
          title: "Unlock Wheel?",
          action: "unlock",
          type: "wheel",
          headerIcon: LockedIcon,
          headerIconProps: {
            style: { width: "24px", height: "24px" },
          },
        })
      );
      return;
    }
    setAccessKeyModalContext("unlock");
    setIsAccessKeyModalOpen(true);
  };

  const handleAccessKeySubmit = (password) => {
    setIsLoading(true);
    unlockWheel.mutate(
      {
        wheelId: data?.id,
        access_code: password,
        lock_type: 2,
      },
      {
        onSuccess: () => {
          toast.success("Wheel unlocked successfully!");
          setIsAccessKeyModalOpen(false);
          setAccessKeyError("");
          if (accessKeyModalContext === "clone") {
            handleClone();
          } else {
            nav(`/wheel/${data?.id}`);
          }
          queryClient.invalidateQueries(["fetchWheels"]);
        },
        onError: (error) => {
          setAccessKeyError(
            error?.response?.data?.message || "Failed to unlock wheel."
          );
        },
        onSettled: () => {
          setIsLoading(false);
        },
      }
    );
  };

  const iconStyles = {
    fontSize: 16,
    color: colors.lightGrey,
  };

  const menuItems = [
    {
      key: menuItemKeys.VIEW,
      label: "View Wheel",
      icon: <VisibilityOutlinedIcon style={iconStyles} />,
      action: handleView,
    },
    {
      key: menuItemKeys.EDIT,
      label:
        isOpenMenuWheelCloned && (isOpenMenuWheelLive || isOpenMenuWheelLocked)
          ? "Cannot Edit a Synced Clone"
          : "Edit",
      icon: <EditIcon style={{ width: "20px", height: "20px" }} />,
      action: handleEdit,
      isDisabled:
        isOpenMenuWheelCloned && (isOpenMenuWheelLive || isOpenMenuWheelLocked),
    },
    {
      key: menuItemKeys.CLONE,
      label: isOpenMenuWheelClonable ? "Clone" : "Cloning Disabled",
      isDisabled: !isOpenMenuWheelClonable,
      icon: isOpenMenuWheelClonable ? (
        <img
          src={cloneSvg}
          className="img-fluid"
          alt="Edit"
          width="15"
          height="15"
        />
      ) : (
        <img
          style={{ height: "16px" }}
          alt="Clone disabled"
          src={ASSETS.CloningDisabled}
        ></img>
      ),
      action: handleClone,
    },
    {
      key: menuItemKeys.PRIMARY,
      label: "Make Primary",
      icon: <StarIcon sx={{ color: "#FFC700", fontSize: "18px" }} />,
      action: handleMakePrimary,
    },
    {
      key: menuItemKeys.REMOVE_PRIMARY,
      label: "Remove from Primary",
      icon: <img src={Unstar} alt="Primary" width="16" height="16" />,
      action: handleRemovePrimary,
    },
    {
      key: menuItemKeys.VISIBILITY,
      label: data.visibility === 2 ? "Change to Public" : "Change to Private",
      icon:
        data.visibility === 2 ? (
          <PublicIcon style={iconStyles} />
        ) : (
          <VisibilityOffIcon style={iconStyles} />
        ),
      action: handleToggleVisibility,
    },
    {
      key: menuItemKeys.DUPLICATE,
      label: "Duplicate",
      icon: <DuplicateIcon style={{ width: 15, height: 15 }} />,
      action: handleDuplicate,
    },
    {
      key: menuItemKeys.SHARE,
      label: "Share",
      icon: <ShareIcon style={{ width: "20px", height: "20px" }} />,
      action: handleShare,
    },
    {
      key: menuItemKeys.DOWNLOAD,
      label: "Download Image",
      icon: (
        <DownloadIcon style={iconStyles} sx={{ color: "#8BD7A0 !important" }} />
      ),
      action: handleDownload,
    },
    {
      key: menuItemKeys.DELETE,
      label: "Delete",
      icon: (
        <DeleteOutlinedIcon
          style={iconStyles}
          sx={{ color: "#E54D2E !important" }}
        />
      ),
      action: handleDelete,
    },
    {
      key: menuItemKeys.FAVORITE,
      label: isOpenMenuWheelFavorited ? "Unfavorite" : "Favorite",
      icon: isOpenMenuWheelFavorited ? (
        <FavoriteIcon style={iconStyles} sx={{ color: "#E25297 !important" }} />
      ) : (
        <FavoriteBorderOutlinedIcon
          style={iconStyles}
          sx={{ color: "#E25297 !important" }}
        />
      ),
      action: handleFavorite,
    },
    {
      key: menuItemKeys.REPORT,
      label: "Report",
      icon: (
        <InfoOutlineIcon
          style={iconStyles}
          sx={{ color: "#E54D2E !important" }}
        />
      ),
      action: handleReport,
    },
    {
      key: menuItemKeys.MOVE,
      label: "Move to Folder",
      icon: (
        <DriveFileMoveIcon
          style={iconStyles}
          sx={{ color: "#C283DA !important" }}
        />
      ),
      action: handleMoveToFolder,
    },
    {
      key: menuItemKeys.UNLOCK,
      label: "Unlock",
      icon: <UnlockIcon style={{ width: "16px", height: "16px" }} />,
      action: handleUnlock,
    },
  ];

  const filteredMenuItems = menuItems
    // First filter by include if specified
    .filter((item) => (include.length ? include.includes(item.key) : true))
    // Then always filter out excluded items
    .filter((item) => !exclude.includes(item.key));

  // Add custom menu items to the filtered list
  const finalMenuItems = [...filteredMenuItems, ...customMenuItems];

  // Separate bottom items (delete/report) so they always appear at the bottom
  const bottomKeys = [menuItemKeys.DELETE, menuItemKeys.REPORT];
  const topMenuItems = finalMenuItems.filter(
    (it) => !bottomKeys.includes(it.key)
  );
  const bottomMenuItems = finalMenuItems.filter((it) =>
    bottomKeys.includes(it.key)
  );

  return (
    <>
      {isLoading && (
        <BackdropSpinner open={isLoading} />
      )}
      <Menu
        portal={true}
        viewScroll="close"
        direction="bottom"
        menuButton={
          <MenuButton
            style={{
              backgroundColor: "transparent",
              border: "none",
              cursor: "pointer",
              width: 20,
            }}
          >
            <ThreeDotIcon fontSize="small" />
          </MenuButton>
        }
        menuStyle={{
          border: "1px solid #ddd",
          borderRadius: "8px",
          padding: "8px",
          zIndex: 9999,
          background: "white",
          boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
          width: "200px",
        }}
      >
        {topMenuItems.map((item, index) => (
          <MenuItem
            key={`${item?.key}-${index}`}
            onClick={item.action}
            disabled={item.isDisabled}
            style={{
              display: "flex",
              alignItems: "center",
              gap: "8px",
              padding: "10px",
              cursor: item.isDisabled ? "not-allowed" : "pointer",
              fontSize: "14px",
              fontFamily: "DM Sans, sans-serif",
              color: item.isDisabled ? "#9E9E9E" : colors.textBlue,
              borderRadius: "6px",
              opacity: item.isDisabled ? 0.6 : 1,
            }}
          >
            {item.icon} {item.label}
          </MenuItem>
        ))}

        {bottomMenuItems.length > 0 && (
          <>
            <div
              style={{ height: 1, background: "#F7F2FA", margin: "6px 0" }}
            />
            {bottomMenuItems.map((item, index) => (
              <MenuItem
                key={`${item?.key}-bottom-${index}`}
                onClick={item.action}
                disabled={item.isDisabled}
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                  padding: "10px",
                  cursor: item.isDisabled ? "not-allowed" : "pointer",
                  fontSize: "14px",
                  fontFamily: "DM Sans, sans-serif",
                  color: item.isDisabled ? "#9E9E9E" : colors.textBlue,
                  borderRadius: "6px",
                  opacity: item.isDisabled ? 0.6 : 1,
                }}
              >
                {item.icon} {item.label}
              </MenuItem>
            ))}
          </>
        )}
      </Menu>
      <LegacyWheelModal
        onClose={() => setshowLegacyModal(false)}
        open={showLegacyModal}
      />
      {openShare && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            background: "rgba(154, 159, 170, 0.7)", // light grey overlay
            zIndex: 1000,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <ShareModal
            onGallery={true}
            userData={userData}
            chartData={data?.wheel_segments}
            wheelBackground={wheelBackground}
            wheel={wheelData}
            handleClose={() => setOpenShare(false)}
            color={wheelData?.wallpaper_settings?.segment_bg_color ?? "#000000"}
            currentBg={wheelData?.wallpaper_settings?.current_bg ?? 1}
            bgWallpaper={wheelData?.wallpaper_settings?.bg_wallpaper ?? ""}
            wallpaperTransparency={
              wheelData?.wallpaper_settings?.wallpaper_transparency ?? ""
            }
          />
        </div>
      )}
      <MoveToFolderModal
        isOpen={showMoveToFolderModal}
        sourceType="wheel"
        sourceId={data?.id}
        onMovePress={handleMoveComplete}
        onClose={() => setShowMoveToFolderModal(false)}
        onCancelPress={() => setShowMoveToFolderModal(false)}
      />
      {openPopup && (
        <WheelLimitPopup
          open={openPopup}
          handleClose={() => setOpenPopup(false)}
          type="clone"
        />
      )}
      <AccessKeyEnterModal
        isOpen={isAccessKeyModalOpen}
        handleClose={() => setIsAccessKeyModalOpen(false)}
        onSubmit={handleAccessKeySubmit}
        error={accessKeyError}
        setError={setAccessKeyError}
        description={
          accessKeyModalContext === "clone"
            ? "To Clone this Wheel, please unlock it first by entering the password."
            : "To unlock this Wheel, please enter the password."
        }
      />
      {/* Screenshot functionality moved to backend Lambda */}
      {/* <ScreenshotModal
        isOpen={isScreenshotModalOpen}
        onClose={() => setIsScreenshotModalOpen(false)}
        segmentBgColor={data?.wallpaper_settings?.segment_bg_color ?? "#000000"}
        currentBg={data?.wallpaper_settings?.current_bg ?? 1}
        base64Wallpaper={base64Wallpaper}
        wallpaperTransparency={
          data?.wallpaper_settings?.wallpaper_transparency ?? ""
        }
        chartData={data?.wheel_segments}
        userData={userDataForScreenshot}
        wheel={data}
        // showPreview={true}
      /> */}

      {/* Modern MUI Primary Wheel Dialog */}
      <Dialog
        open={showPrimaryDialog}
        onClose={handleCancelPrimary}
        maxWidth="sm"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: "16px",
            padding: "8px",
            boxShadow: "0px 24px 48px rgba(0, 0, 0, 0.12)",
          },
        }}
      >
        <DialogTitle
          sx={{
            display: "flex",
            alignItems: "center",
            gap: "12px",
            padding: "24px 24px 16px 24px",
            fontSize: "20px",
            fontWeight: 600,
            color: colors.textBlue,
            fontFamily: "DM Sans, sans-serif",
          }}
        >
          <PublicIcon sx={{ color: "green", fontSize: "28px" }} />
          Make This Wheel Public?
        </DialogTitle>

        <DialogContent sx={{ padding: "16px 24px 24px 24px" }}>
          <Box sx={{ display: "flex", alignItems: "flex-start", gap: "12px" }}>
            <Typography
              sx={{
                fontSize: "16px",
                lineHeight: "20px",
                color: colors.textBlue,
                fontFamily: "DM Sans, sans-serif",
              }}
            >
              Designating this Private Wheel as your Primary Wheel will change
              its visibility to Public.
            </Typography>
          </Box>
        </DialogContent>

        <DialogActions
          sx={{
            padding: "16px 24px 24px 24px",
            gap: "12px",
          }}
        >
          <Button
            onClick={handleCancelPrimary}
            variant="outlined"
            sx={{
              borderRadius: "8px",
              textTransform: "none",
              fontSize: "14px",
              fontWeight: 500,
              padding: "10px 24px",
              borderColor: "#E5E7EB",
              color: colors.textBlue,
              fontFamily: "DM Sans, sans-serif",
              "&:hover": {
                borderColor: "#D1D5DB",
                backgroundColor: "#F9FAFB",
              },
            }}
          >
            Cancel
          </Button>
          <Button
            onClick={handleProceedPrimary}
            variant="contained"
            sx={{
              borderRadius: "8px",
              textTransform: "none",
              fontSize: "14px",
              fontWeight: 500,
              padding: "10px 24px",
              backgroundColor: "#9B5AF8",
              color: "white",
              fontFamily: "DM Sans, sans-serif",
              boxShadow: "none",
              "&:hover": {
                backgroundColor: "#8B4AE8",
                boxShadow: "none",
              },
            }}
          >
            Proceed
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default WheelCardThreeDotMenu;
